import type { CounterpartyContactInput } from "../entities/counterparties";

export interface ContactDraft {
  email: string;
  name: string;
  position: string;
  is_primary: boolean;
}

export const emptyContactDraft: ContactDraft = {
  email: "",
  name: "",
  position: "",
  is_primary: false,
};

/** Пустые необязательные поля не отправляются: сервер принимает их отсутствие. */
export function contactInput(draft: ContactDraft): CounterpartyContactInput {
  return {
    email: draft.email.trim(),
    ...(draft.name.trim() === "" ? {} : { name: draft.name.trim() }),
    ...(draft.position.trim() === ""
      ? {}
      : { position: draft.position.trim() }),
    ...(draft.is_primary ? { is_primary: true } : {}),
  };
}
